const BASE_API = process.env.REACT_APP_BASE_API;
const AUTH_API = process.env.REACT_APP_AUTH_API; 
const APP_ID = process.env.REACT_APP_APP_ID;  
export const CONSTANTS = {
  APP_ID: APP_ID, 
  Login: AUTH_API + 'api/Account/Login',

  DashboardData:
    BASE_API + 'SurveyApi/GetSurveyRequestsDataForDashboard',

 
};
